<template>  
  <v-layout class="map-control" >          
    <v-navigation-drawer stateless class="sub-drawer" :value="showSubDrawer" floating touchless disable-resize-watcher disable-route-watcher  >
      <v-toolbar flat>      
        <v-toolbar-title v-text="panelTitle"></v-toolbar-title>                  
        <v-spacer />
        <v-btn icon @click.stop.prevent="draweractive = ''" class="ma-0" ><v-icon>mdi-close</v-icon></v-btn>                      
      </v-toolbar>    
      <div style="overflow:auto;height: calc(100% - 64px);">
        <v-scale-transition >  
          <diV @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE')">
            <map-panel-base-layer :uiid="uiid" v-show="showBaseLayerPanel" class="pa-2" />
          </diV>
        </v-scale-transition>                     
        <v-scale-transition >          
          <diV @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE')"><map-panel-glider :uiid="uiid" v-show="showGliderPanel" class="pa-2" /></diV>                    
        </v-scale-transition>             
        <v-scale-transition >  
          <diV @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE')"><map-panel-layer :uiid="uiid" v-show="showLayerPanel" /></diV>                  
        </v-scale-transition>
        <v-scale-transition >  
          <map-panel-tools :uiid="uiid" v-show="showToolsPanel" @click.stop.prevent="" />
        </v-scale-transition>    
        <v-scale-transition >  
          <diV @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE')"><map-panel-properties v-show="showPropertiesPanel" class="pa-2" /></diV>          
        </v-scale-transition>                           
      </div>                  
    </v-navigation-drawer>    
    <v-navigation-drawer class="main-drawer" permanent touchless disable-resize-watcher disable-route-watcher  mini-variant>
      <v-list class="pt-0">
        <v-btn :input-value="showBaseLayerPanel" @click.stop.prevent="draweractive = draweractive=='baselayer'?'':'baselayer'" flat class="dbtn ma-0" :title="$t('Pilot.BaseLayer.Tooltip')"><v-icon>mdi-map</v-icon></v-btn>
        <v-btn v-if="!hideGliderSection"  :input-value="showGliderPanel" @click.stop.prevent="draweractive = draweractive=='glider'?'':'glider'" flat class="dbtn ma-0" :title="$t('Pilot.Glider.Tooltip')"><img width="28" height="28" :src="require('@/assets/glider.png')" /></v-btn>
        <v-btn :input-value="showLayerPanel" @click.stop.prevent="draweractive = draweractive=='layer'?'':'layer'" flat class="dbtn ma-0" :title="$t('Pilot.Layer.Tooltip')"><v-icon>mdi-layers</v-icon></v-btn>
        <v-btn v-if="!hideToolsSection" :input-value="showToolsPanel" @click.stop.prevent="draweractive = draweractive=='tools'?'':'tools'" flat class="dbtn ma-0" :title="$t('Pilot.Tools.Tooltip')"><v-icon>mdi-wrench</v-icon></v-btn>
        <v-btn v-if="!hideInfosSection" :input-value="showPropertiesPanel" @click.stop.prevent="draweractive = draweractive=='property'?'':'property'" flat class="dbtn ma-0" :title="$t('Pilot.Info.Tooltip')"><v-icon>mdi-information</v-icon></v-btn>        
      </v-list>
   </v-navigation-drawer>
  </v-layout>
</template>
<script>  
  import MapPanelGlider from '@/components/map/MapPanelGlider'
  import MapPanelLayer from '@/components/map/MapPanelLayer'
  import MapPanelBaseLayer from '@/components/map/MapPanelBaseLayer'
  import MapPanelTools from '@/components/map/MapPanelTools'
  import MapPanelProperties from '@/components/map/MapPanelProperties'  
  
  export default {
    name: 'MapControl',
    components: {MapPanelGlider,MapPanelLayer,MapPanelBaseLayer,MapPanelTools,MapPanelProperties},    
    props:{
      uiid:{
          type: String,
          required: true
      },
      hideGliderSection:{
          type: Boolean,
          default: false
      },
      hideInfosSection:{
          type: Boolean,
          default: true
      },
      hideToolsSection:{
          type: Boolean,
          default: false
      }
    },
    data() {
      return {   
        draweractive:''
      }
    },
   computed: {       
         showSubDrawer() {
            return this.draweractive != ''
         },
         showGliderPanel:{
           get() { return this.draweractive == 'glider' },
           set(value){ this.draweractive = value?'glider':'' }
         },
         showLayerPanel:{
           get(){ return this.draweractive == 'layer' },
           set(value){ this.draweractive = value?'layer':'' }
         },
         showBaseLayerPanel:{ 
           get(){ return this.draweractive == 'baselayer' },
           set(value){ this.draweractive = value?'baselayer':'' }
         },                
         showToolsPanel:{
           get(){ return this.draweractive == 'tools' },
           set(value){ this.draweractive = value?'tools':'' }
         },         
         showPropertiesPanel:{
           get(){ return this.draweractive == 'property' },
           set(value){ this.draweractive = value?'property':'' }
         },
         panelTitle(){
           switch (this.draweractive) {
              case 'glider': return this.$t('Pilot.Glider.Title')
              case 'layer': return this.$t('Pilot.Layer.Title')
              case 'baselayer': return this.$t('Pilot.BaseLayer.Title')
              case 'property': return this.$t('Pilot.Info.Title')
              case 'tools': return this.$t('Pilot.Tools.Title')
              default: return ''
           }           
         }
    },
    methods:{
      test(){
        alert('test')
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope lang="scss">

$btnDim : 50px;

.map-control{
  position: relative;     
}

.dbtn{
  width: $btnDim!important;
  min-width:$btnDim!important;
  max-width:$btnDim!important;
  height: $btnDim!important;
  min-height:$btnDim!important;
  max-height:$btnDim!important;
}

.main-drawer{    
  width: $btnDim!important;
  min-width:$btnDim!important;
  max-width:$btnDim!important;
  box-sizing: border-box;
}

.sub-drawer{  
  position: absolute;
  opacity: 0.8;    
  top:0px;
  bottom:0px;  
  left: $btnDim;
  max-width: inherit;  
}

.map-control:hover .sub-drawer{
  opacity: 1;
} 

.sub-drawer form{
  position: absolute;
}

.v-input--switch {
  margin-top: 0px; 
}

</style>
